// AROMIY THEME JS

document.addEventListener('DOMContentLoaded', function () {

  // ── CART DRAWER ──
  const cartOverlay = document.getElementById('cart-overlay');
  const cartDrawer = document.getElementById('cart-drawer');
  const cartClose = document.getElementById('cart-close');
  const cartIcon = document.getElementById('cart-icon-btn');

  function openCart() {
    cartOverlay?.classList.add('open');
    cartDrawer?.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    cartOverlay?.classList.remove('open');
    cartDrawer?.classList.remove('open');
    document.body.style.overflow = '';
  }

  cartIcon?.addEventListener('click', openCart);
  cartClose?.addEventListener('click', closeCart);
  cartOverlay?.addEventListener('click', closeCart);

  // ── ADD TO CART ──
  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', async function (e) {
      e.preventDefault();
      const variantId = this.dataset.variantId;
      if (!variantId) return;

      this.textContent = 'جاري الإضافة...';
      this.disabled = true;

      try {
        const res = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (res.ok) {
          await updateCartCount();
          openCart();
          await renderCartItems();
          this.textContent = '✓ تمت الإضافة';
          setTimeout(() => {
            this.textContent = this.dataset.originalText || 'أضف للسلة';
            this.disabled = false;
          }, 2000);
        }
      } catch (err) {
        this.textContent = this.dataset.originalText || 'أضف للسلة';
        this.disabled = false;
      }
    });

    btn.dataset.originalText = btn.textContent;
  });

  // ── UPDATE CART COUNT ──
  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      const count = cart.item_count;
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = count;
        el.style.display = count > 0 ? 'flex' : 'none';
      });
    } catch (e) {}
  }

  // ── RENDER CART ITEMS ──
  async function renderCartItems() {
    const container = document.getElementById('cart-items-container');
    const totalEl = document.getElementById('cart-total-price');
    if (!container) return;

    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();

      if (cart.item_count === 0) {
        container.innerHTML = '<div class="cart-empty"><p>سلتك فارغة</p></div>';
        if (totalEl) totalEl.textContent = '0 ر.س';
        return;
      }

      container.innerHTML = cart.items.map(item => `
        <div class="cart-item" style="display:flex;gap:12px;margin-bottom:16px;padding-bottom:16px;border-bottom:1px solid rgba(201,168,76,0.1)">
          <img src="${item.image}" alt="${item.title}" style="width:70px;height:70px;object-fit:cover;border-radius:8px;border:1px solid rgba(201,168,76,0.2)">
          <div style="flex:1">
            <p style="font-size:0.9rem;font-weight:600;color:#f0e8d8;margin-bottom:4px">${item.product_title}</p>
            <p style="font-size:0.8rem;color:#a89878;margin-bottom:8px">${(item.price / 100).toFixed(0)} ر.س</p>
            <div style="display:flex;align-items:center;gap:8px">
              <button onclick="updateQty(${item.key}, ${item.quantity - 1})" style="background:rgba(201,168,76,0.1);border:1px solid rgba(201,168,76,0.2);color:#C9A84C;width:28px;height:28px;border-radius:50%;cursor:pointer;font-size:1rem">−</button>
              <span style="color:#f0e8d8;font-size:0.9rem">${item.quantity}</span>
              <button onclick="updateQty(${item.key}, ${item.quantity + 1})" style="background:rgba(201,168,76,0.1);border:1px solid rgba(201,168,76,0.2);color:#C9A84C;width:28px;height:28px;border-radius:50%;cursor:pointer;font-size:1rem">+</button>
            </div>
          </div>
        </div>
      `).join('');

      if (totalEl) totalEl.textContent = (cart.total_price / 100).toFixed(0) + ' ر.س';
    } catch (e) {}
  }

  window.updateQty = async function (key, qty) {
    if (qty < 1) {
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) });
    } else {
      await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) });
    }
    await updateCartCount();
    await renderCartItems();
  };

  // ── PRODUCT GALLERY THUMBS ──
  document.querySelectorAll('.product-thumb').forEach(thumb => {
    thumb.addEventListener('click', function () {
      const main = document.getElementById('product-main-img');
      if (main) main.src = this.src;
      document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
      this.classList.add('active');
    });
  });

  // ── STICKY HEADER SCROLL ──
  const header = document.querySelector('.site-header');
  const announcementBar = document.querySelector('.announcement-bar');
  if (header && announcementBar) {
    window.addEventListener('scroll', () => {
      const barHeight = announcementBar.offsetHeight;
      if (window.scrollY > barHeight) {
        header.style.top = '0';
      } else {
        header.style.top = barHeight + 'px';
      }
    });
  }

  // Init
  updateCartCount();
});
